import { takeLatest } from 'redux-saga/effects';
import { RELOAD_BET_POSITION } from '../../actions/betPosition';
import { LOAD_PUBLISH_TERMS_SUCCESS } from '../../actions/publishTerms';
import { loadBetPosition } from './loadBetPosition';

export function* betPositionSagas() {
  yield takeLatest([LOAD_PUBLISH_TERMS_SUCCESS, RELOAD_BET_POSITION], loadBetPosition);
}
